import utils from '../modules/utils';
import {mapGetters} from 'vuex';

/**
 * List the mutations keys used in the service
 * @type {Array}
 */
const requiredMutationsKeys = [
  'SET_SF_ID',
  'SET_PAYMENT_WALLET_UID',
  'SET_CUSTOMER_NUMBER',
  'SET_TEST_LEVEL',
  'SET_TRACKING_CODE',
  'SET_CAMPAIGN_CODE',
  'SET_MB_PARAMS',
  'SET_MARKETING_CLOUD_PARAMS',
  'SET_PAYMENT_ID',
  'SET_EXTERNAL_PARTNER_ID',
  'SET_LEAD_TRACKING_CODE'
];

export default {
  name: 'MixinQueryParameters',
  computed: {
    ...mapGetters([
      'locale'
    ])
  },
  methods: {
    /**
     * Retrieve useful query params and store them
     */
    getQueryParams(mutations) {
      /**
       * Ensure to be able to store information properly
       */
      const mutationKeys = Object.keys(mutations);
      const missingMutationKeys = requiredMutationsKeys.filter(requiredMutation => !mutationKeys.includes(requiredMutation));

      if (missingMutationKeys.length > 0) {
        throw new Error(`The current mode does not have those required mutation keys: ${missingMutationKeys.join(', ')}`);
      }

      /**
       * Retrieve and store useful query params
       */
      const queryParams = utils.getQueryParams();

      /**
       * SF ID for 1click with salesforce customers
       * Get sfId from cookie and override it if also in query string
       */
      const atlasDataCookie = this.$cookies.get('atlasData');

      let sfIdFromCookie = '';
      if (atlasDataCookie && typeof atlasDataCookie === 'object' && atlasDataCookie.sfId) {
        sfIdFromCookie = atlasDataCookie.sfId;
      }

      let sfId = queryParams.sfId ? queryParams.sfId : sfIdFromCookie;
      const regex = /^[a-zA-Z0-9]*$/;

      if (sfId && !regex.test(sfId)) {
        sfId = sfId.replace(/[^a-z0-9.]+/ig, '');
      }

      this.$store.commit(mutations.SET_SF_ID, sfId);

      /**
       * Get and store walletId
       */
      const {walletId} = queryParams;

      if (walletId) {
        this.$store.commit(mutations.SET_PAYMENT_WALLET_UID, regex.test(walletId) ? walletId : null);
      }

      // Customer number for 1click with non-salesforce customers
      const customerNumber = queryParams.customerNumber ? queryParams.customerNumber : '';
      this.$store.commit(mutations.SET_CUSTOMER_NUMBER, customerNumber);

      // Retrieve test level
      // - "vanguard_only"   : The order remains in Vanguard (no call to Orion)
      // - "orion_only"      : The order goes through vanguard and orion and stops (no call from Orion to other systems)
      // - "salesforce_only" : All SF objects are created, but not synchronized outside from SF
      // - "TEST"            : All SF objects are created and synchronized with the "TEST" flag
      let testLevel = queryParams.testLevel ? queryParams.testLevel : '';
      if (queryParams.isBat && (queryParams.isBat === '1' || queryParams.isBat === 'true')) {
        testLevel = 'salesforce_only';
      }

      const externalPartnerId = queryParams.externalPartnerId ? queryParams.externalPartnerId : '';

      if (testLevel !== '' && testLevel !== 'vanguard_only' && testLevel !== 'orion_only' && testLevel !== 'salesforce_only' && testLevel !== 'TEST' && !document.location.pathname.includes('error.html')) {
        window.location = window.location.origin + '/static/' + this.locale + '/error.html' + document.location.search;
        return;
      }

      this.$store.commit(mutations.SET_TEST_LEVEL, testLevel);

      // Tracking code
      const trackingCode = queryParams.trackingCode ? queryParams.trackingCode : 'XMISSING';
      this.$store.commit(mutations.SET_TRACKING_CODE, trackingCode);

      // Campaign code
      const campaignCode = queryParams.campaignCode ? queryParams.campaignCode : '';
      this.$store.commit(mutations.SET_CAMPAIGN_CODE, campaignCode);

      // Mindbaz tracking params
      const base = queryParams.base ? queryParams.base : '';
      const campaignId = queryParams.campaignId ? queryParams.campaignId : '';
      const shootId = queryParams.shootId ? queryParams.shootId : '';
      const segmentId = queryParams.segmentId ? queryParams.segmentId : '';
      this.$store.commit(mutations.SET_MB_PARAMS, {base, campaignId, shootId, segmentId});

      // Marketing cloud tracking params
      const marketingCloudDataSourceName = queryParams.d ? queryParams.d : '';
      const marketingCloudJobId = queryParams.j ? queryParams.j : '';
      const marketingCloudListId = queryParams.l ? queryParams.l : '';
      const marketingCloudBatchId = queryParams.b ? queryParams.b : '';
      const marketingCloudSk = queryParams.sk ? queryParams.sk : '';
      const marketingCloudSendDate = queryParams.senddate ? queryParams.senddate : '';

      this.$store.commit(mutations.SET_MARKETING_CLOUD_PARAMS, {
        marketingCloudDataSourceName,
        marketingCloudJobId,
        marketingCloudListId,
        marketingCloudBatchId,
        marketingCloudSk,
        marketingCloudSendDate
      });

      // Payment ID, for recapture
      const paymentId = queryParams.paymentId ? queryParams.paymentId : '';
      this.$store.commit(mutations.SET_PAYMENT_ID, paymentId);

      const recaptureIdentifier = queryParams.recaptureIdentifier ? queryParams.recaptureIdentifier : '';
      this.$store.commit(mutations.SET_RECAPTURE_IDENTIFIER, recaptureIdentifier);

      const resubmit = queryParams.isResubmit || false;
      this.$store.commit(mutations.SET_RESUBMIT, resubmit);

      this.$store.commit(mutations.SET_EXTERNAL_PARTNER_ID, externalPartnerId);

      if (queryParams.leadTrackingCode) {
        this.$store.commit(mutations.SET_LEAD_TRACKING_CODE, queryParams.leadTrackingCode);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/query-parameters.js